import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const apiBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  // Only prefix relative URLs (API calls), skip absolute URLs (e.g. OAuth endpoints) and static assets
  if (!req.url.startsWith('http') && !req.url.startsWith('assets/')) {
    return next(req.clone({ url: `${environment.BASE_PATH}${req.url}` }));
  }
  return next(req);
};
